import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Section } from "../../../atoms/Section";
import { Container } from "../../../atoms/Container";
import BreadCrumbBar from "../../../atoms/BreadCrumbBar";
import urlPatterns from "../../../../urls";
import GuidesPosts from "../../../atoms/GuidesPosts";
import { GUIDES_TAB_BAR_SLUG } from "../../../../helpers/constants";

class GuidesGlossaryPostsMain extends PureComponent {
  /**
   * Gets title of page, and also get parent details for breadcrumb navigation.
   * Parent details are only returned if parent is not one of GUIDES_TAB_BAR_SLUG values.
   *
   * @returns {Object}
   * */
  getTitleDetails = () => {
    const { match, posts, parentHomeSlug } = this.props;
    const { params } = match || {};
    const { slug } = params || {};

    let title = null;
    let metaData = {};
    let parentDetails = null;

    posts.forEach((post) => {
      // CASE: Get title for header.
      if (post && post.primary_tag && post.primary_tag.slug === slug) {
        title = post.primary_tag.name;
      } else {
        // eslint-disable-next-line camelcase
        const { meta_title, meta_description } = post || {};
        metaData = { metaTitle: meta_title, metaDescription: meta_description };
      }

      // CASE: Check if this page has a parent that's not one of the home tab 5 slugs.
      if (
        post &&
        post.primary_tag &&
        post.primary_tag.slug !== parentHomeSlug &&
        post.primary_tag.slug !== slug
      ) {
        parentDetails = {
          parentSlug: post.primary_tag.slug,
          parentTitle: post.primary_tag.name,
        };
      }
    });

    return { title, parentDetails, metaData };
  };

  /**
   * This returns the URL for the breadcrumb navigation bar when glossary pages are to be shown.
   *
   * @param {String} slug
   * */
  getChildUrl = (slug) => {
    const { isFromTabGrape, isFromTabMore, isFromTabAll, isFromTabRegion, isFromTabTasting } = this.props;
    if (isFromTabAll) {
      return urlPatterns.GUIDE_101_GLOSSARY(slug || GUIDES_TAB_BAR_SLUG.WINE_101_GUIDES);
    }
    if (isFromTabGrape) {
      return urlPatterns.GUIDE_GRAPE_COLOR_GLOSSARY(slug || GUIDES_TAB_BAR_SLUG.GUIDE_GRAPE_COLOR);
    }
    if (isFromTabRegion) {
      return urlPatterns.GUIDE_REGION_GLOSSARY(slug || GUIDES_TAB_BAR_SLUG.GUIDE_REGION);
    }
    if (isFromTabTasting) {
      return urlPatterns.GUIDE_TASTING_GLOSSARY(slug || GUIDES_TAB_BAR_SLUG.GUIDE_TASTING);
    }
    if (isFromTabMore) {
      return urlPatterns.GUIDE_MORE_GLOSSARY(slug || GUIDES_TAB_BAR_SLUG.GUIDE_MORE);
    }
    return null;
  };

  render() {
    const {
      match,
      history,
      posts,
      parentLabel,
      parentUrl,
      isFromTabAll,
      isFromTabGrape,
      isFromTabRegion,
      isFromTabTasting,
      isFromTabMore,
      location,
    } = this.props;
    const { params } = match || {};
    const { slug } = params || {};

    const { title, parentDetails, metaData } = this.getTitleDetails();
    const { parentSlug, parentTitle } = parentDetails || {};
    let fourLayerBreadCrumb = false;
    if (parentDetails && parentSlug && parentTitle) {
      fourLayerBreadCrumb = true;
    }
    const { metaTitle, metaDescription } = metaData;

    return (
      <Section xxs>
        {fourLayerBreadCrumb ? (
          <BreadCrumbBar
            homeLabel="Guides"
            parentLabel={parentLabel}
            parentUrl={parentUrl}
            childLabel={parentTitle}
            childUrl={this.getChildUrl(parentSlug)}
            grandChildLabel={title}
            location={location}
          />
        ) : (
          <BreadCrumbBar
            homeLabel="Guides"
            parentLabel={parentLabel}
            parentUrl={parentUrl}
            childLabel={title}
            location={location}
          />
        )}
        <Container>
          <GuidesPosts
            history={history}
            filters={`${slug}`}
            metaTitle={metaTitle || title}
            metaDescription={metaDescription}
            posts={posts}
            isFromTabAll={isFromTabAll}
            isFromTabGrape={isFromTabGrape}
            isFromTabRegion={isFromTabRegion}
            isFromTabTasting={isFromTabTasting}
            isFromTabMore={isFromTabMore}
            location={location}
          />
        </Container>
      </Section>
    );
  }
}

GuidesGlossaryPostsMain.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({}).isRequired,
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  parentLabel: PropTypes.string.isRequired,
  parentUrl: PropTypes.string.isRequired,
  parentHomeSlug: PropTypes.string.isRequired,
  isFromTabAll: PropTypes.bool,
  isFromTabGrape: PropTypes.bool,
  isFromTabRegion: PropTypes.bool,
  isFromTabTasting: PropTypes.bool,
  isFromTabMore: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
};

GuidesGlossaryPostsMain.defaultProps = {
  isFromTabAll: false,
  isFromTabGrape: false,
  isFromTabRegion: false,
  isFromTabTasting: false,
  isFromTabMore: false,
};

export default GuidesGlossaryPostsMain;
